// FLP native-<dialog> modal controller — replaces Bootstrap's
// server-rendered `.modal` plumbing for the FLP's share / join /
// campaign / mailto-error modals.
//
// Why: Bootstrap `.modal`s stack via z-index, which loses to anything
// the browser puts in its top layer. When the donation form is itself
// launched in a modal (a native <dialog>), an FLP share modal opened
// from inside it rendered UNDERNEATH the form. Native dialogs live in
// the top layer and stack in open order, so moving the FLP modals to
// <dialog> + showModal() fixes the layering — and lets the mailto-error
// dialog stack cleanly over the share dialog without the hand-rolled
// z-index override the email partial used to carry.
//
// Markup contract (mirrors the v6 widget's packs/widgetModals.js):
//   <dialog class="flp-modal" id="…"> … </dialog>
//   [data-modal-target="<id>"]  opens that dialog
//   [data-modal-close]          closes its containing dialog
//   a click on the dialog's own backdrop closes it
//
// Scroll-lock is pure CSS — `html:has(.flp-modal[open]) { overflow:
// hidden }` in styles/sources/_dialog-modals.scss — so neither this
// controller nor the imperatively-opened dialogs (the join iframe, the
// mailto-error dialog) touch document.documentElement.style.overflow.
// That keeps the FLP from fighting the embed script's dialog.js over
// the same global property (both run on the FLP page): each system's
// CSS locks scroll while its own modals are open, and the browser ORs
// them, so closing one system's dialog can't release the other's lock.
// It also handles stacking within .flp-modal for free.
const openModal = id => {
  const modal = document.getElementById(id)
  if (!modal) return console.error(`FLP modal not found: ${id}`)
  modal.showModal()
}

document.addEventListener('click', e => {
  const opener = e.target.closest('[data-modal-target]')
  if (opener) {
    // preventDefault so an <a> trigger (e.g. campaign "View all") opens
    // the dialog instead of jumping to its #hash.
    e.preventDefault()
    return openModal(opener.dataset.modalTarget)
  }

  const closer = e.target.closest('[data-modal-close]')
  if (closer) return closer.closest('dialog')?.close()

  // Backdrop click: a click landing outside the dialog's content box
  // (the dialog itself has padding: 0, so this is the ::backdrop area)
  // targets the <dialog> element.
  if (e.target.matches('.flp-modal')) e.target.close()
})

export { openModal }
